import Typesense, {Client} from 'typesense'
import { useAuthStore } from '@/stores'
import axios from 'axios'

// Singleton pattern
let typesenseClient: Client | null = null
let actualKey = ''
let searchKey = ''

export const hasSearchKey = () => searchKey !== ''

export const client = () => {
  if (!typesenseClient || actualKey !== searchKey) {
    actualKey = searchKey
    typesenseClient = new Typesense.Client({
      'nodes': [{
        'host': 'search.rutasegura.co', // For Typesense Cloud use xxx.a1.typesense.net
        'port': 443,      // For Typesense Cloud use 443
        'protocol': 'https'   // For Typesense Cloud use https
      }],
      'apiKey': actualKey,
      'connectionTimeoutSeconds': 15,  // Increased from 2 to accommodate slower WiFi connections
      'numRetries': 2,  // Retry failed requests twice
      'retryIntervalSeconds': 0.5  // Wait 500ms between retries
    })
  }
  return typesenseClient
}
let baseURL = ''
if (window.location.hostname === 'localhost') {
  baseURL = 'http://localhost:5001/buseticas-7f9fd/us-central1/'
} else {
  baseURL = import.meta.env.DEV
  ? `https://${import.meta.env.VITE_TAIL}/buseticas-7f9fd/us-central1/`
  : 'https://us-central1-buseticas-7f9fd.cloudfunctions.net/'
}
export const renovateClient = async (instanceID: string) => {
  // Change the key to force the client to be recreated
  const keyResponse = await axios.post(`${baseURL}generateTypesenseApiKey`, {
    instanceID
  })
  if (keyResponse.status === 200) {
    searchKey = keyResponse.data.apiKey
  }
  client()
}

export const runSearch = async (searchText, searches, instanceID) => {
  if (!searchText) {
    return
  }
  const searchRequests = {
    searches
  }
  const commonSearchParams =  {
    q: searchText,
    prioritize_exact_match: true,
  }
  let searchResult
  try {
    if (!hasSearchKey()) throw new Error('Forbidden - a valid `x-typesense-api-key` header must be sent')
    searchResult = await client().multiSearch.perform(searchRequests, commonSearchParams)
  } catch (error) {
    const authStore = useAuthStore()
    if (((error as Error).message).includes('Forbidden')) {
      authStore.gettingSearchKey = true
      await renovateClient(instanceID)
      searchResult = await client().multiSearch.perform(searchRequests, {...commonSearchParams, q: searchText})
      authStore.gettingSearchKey = false
    }
  }
  return searchResult
}
